import { useContext } from 'react';
import { onChangeContext } from '../context';

export const useOnChange = () => {
  const onChange = useContext(onChangeContext);
  return onChange;
};
